import { useParams } from "react-router-dom";
import Utils from "../../../../utils/Utils";
import { useContext, useEffect, useState } from "react";
import UserData from "../../../../services/UserData";
import UserService from "../../../../services/UserService";
import ListHeadingWithSearch from "../../../../shared_components/ListHeadingWithSearch/ListHeadingWithSearch";
import ItemList from "../../../../shared_components/ItemList/ItemList";
import UserItem from "./UserItem/UserItem";
import InfoPage from "../../../InfoPage/InfoPage";
import Spinner from "../../../../shared_components/Spinner/Spinner";
import PaginationGroup from "../../../../shared_components/PaginationGroup/PaginationGroup";
import ListContainerWithOptions from "../../../../shared_components/ListContainerWithOptions/ListContainerWithOptions";
import style from "./UsersManagement.module.css";

const UserManagement = () => {
    const { page } = useParams();
    const safePage = Utils.isNull(page) ? 1 : page;
    const [searchText, setSearchText] = useState("");
    const [userList, setUserList] = useState(null);
    const userData = useContext(UserData);
    const [error, setError] = useState(null);
    const [pages, setPages] = useState(0);
    const [activePage, setActivePage] = useState(safePage);
    const [userListVersion, setUserListVersion] = useState(0);
    const [hideDeactivatedUser, setUserShowDeactivatedToggleSearch] = useState(true);

    const searchUsers = (searchTextFromTextBox) => {
        setSearchText(searchTextFromTextBox);
        setActivePage(1);
    }

    const updateUserListVersion = () => {
        setUserListVersion(old => old + 1);
    }

    useEffect(() => {
        UserService.getUsersByStatus(userData, activePage, searchText, hideDeactivatedUser).then(data => {
            setUserList(data.content);
            setPages(data.totalPages);
        }).catch(error => {
            setError(error.message);
        })
    }, [userData, activePage, searchText, userListVersion, hideDeactivatedUser]);
    
    const updatePageClicked = (page) => {
        setActivePage(page);
    }

    const getHeadings = () => {
        return {
            username: "Username",
            role: "Role",
            active: "Status"
        }
    }

    const getList = () => {
        return userList
            .map(userItem => <UserItem key={userItem.id} userItem={userItem} updateList={updateUserListVersion} />);
    }

    const getUsersListView = () => {
        return (
          <ItemList>
            <UserItem 
              userItem={getHeadings()}
              heading={true}
            />
            <div>
              {getList()}
            </div>
          </ItemList>
        )
      }

    const getUsersView = () => {
        if (!Utils.isNull(error)) {
            return <InfoPage description={error} reason="Unable to retrieve users." />;
        }

        if (Utils.isNull(userList)) {
            return <Spinner />
        }
        
        return getUsersListView()
    }

    const getPagination = () => {
        if (pages === 1) {
            return null;
        }
        return <PaginationGroup activePage={activePage} numberOfPages={pages} updatePageClicked={updatePageClicked}/>
    }

    return (
        <ListContainerWithOptions>
            <ListHeadingWithSearch
                searchAction={searchUsers}
            >
                Users
            </ListHeadingWithSearch>
            <div className={style.disable_options}>
                <input type="checkbox" checked={hideDeactivatedUser} onChange={(e) => setUserShowDeactivatedToggleSearch(e.target.checked) }/>
                <span>Hide Deactivated Users</span>
            </div>
            {getUsersView()}
            {getPagination()}
        </ListContainerWithOptions>
    )
}

export default UserManagement;